var map = {
	"./dress-code.jpg": 6749,
	"./home-eccellenza.jpg": 4020,
	"./home-header.jpg": 6546,
	"./home-kafes.jpg": 6905,
	"./home-mulini-def.jpg": 4071,
	"./home-mulini.jpg": 7557,
	"./home-piccola-venezia.jpg": 9283,
	"./home-sirtaki.jpg": 9036,
	"./home-superstizioni-greche.jpg": 2111,
	"./home-uccello-buon-augurio.jpg": 8732,
	"./hotel-myconian.jpg": 2198,
	"./icon-contacts.png": 4653,
	"./icon-dress.png": 3407,
	"./icon-foto-e-video.png": 917,
	"./icon-home.png": 3079,
	"./icon-info.png": 5143,
	"./icon-plane.png": 5723,
	"./icon-program.png": 6041,
	"./logo-edenred.png": 6168,
	"./programma-giorno-1.jpg": 1071,
	"./programma-giorno-2.jpg": 5280,
	"./programma-giorno-3.jpg": 1040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;